import { render, staticRenderFns } from "./MoleculeFeedSectionEmpty.vue?vue&type=template&id=76808d21&"
import script from "./MoleculeFeedSectionEmpty.vue?vue&type=script&lang=js&"
export * from "./MoleculeFeedSectionEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports